import React, { useEffect, useState, Fragment } from 'react'
// component
import Wrapper from '../../../../common/component/Wrapper';
import AntSelect, { AntOption } from '../../../../common/component/AntSelect';
import { Tooltip, Icon, Radio } from 'antd';
import DualListBox from 'react-dual-listbox';
//function common
import * as Func from '../../../../../../helpers/functions';
import * as HMS from '../../../../common/component/Index';
import { PATHS, HOTEL } from "../../../../../../constants/Define";
import CONFIG from '../../../../../../constants/Config';
import { fillHotelNameForRatePlan } from '../../../../../../utils/commonUtils';

const ListHotelRate = ({ ...props })=>{

    //useState
    const [countGetHotel, setCountGetHotel] = useState(0)
    const [ratePlanSelected, setRatePlanSelected] = useState([]);
    const [allRatePlan, setAllRatePlan] = useState([]);
    const [rateType, setRateType] = useState([]);
    const [filterStatus, setFilterStatus] = useState(true);
    const [hotelIds, setHotelIds] = useState([]);
    const [isWarning, setWarning] = useState(false);
    const [isOnBlurHotel, setIsOnBlurHotel] = useState(true);
    const [isCheckHotelIds, setIsCheckHotelIds] = useState(false);
    const [firstTime, setFirstTime] = useState(false);
    //hooks
    const { t, getAllHotel, hotelState, rateState, getListRatesByHotels, typeMarkup } = props;
    const { allHotels } = hotelState;
    const { isFetchingRatesByHotels, dataListRateByHotels } = rateState;

    useEffect(() => {
        setHotelIds(props.hotelIds);
        setFirstTime(true);
    }, [props.hotelIds])

    useEffect(() => {
        setRateType([Object.entries(HOTEL.TYPE_RATE[CONFIG.ENV])[typeMarkup === 'Hotel' ? 0 : 1][0]]);
    }, [typeMarkup]);

    useEffect(() => {
        if(hotelIds.length > 0 && hotelIds.length === allHotels.length){
            setIsCheckHotelIds(true)
            return;
        } return setIsCheckHotelIds(false);
    }, [hotelIds,allHotels])

    useEffect(() => {
        setRatePlanSelected(props.rateSelected)
    }, [props.rateSelected])

    useEffect(() => {
        getAllHotel && getAllHotel();
    }, []);

    useEffect(() => {
        if (hotelIds && hotelIds.length > 0) {
            setRatePlanSelected([...ratePlanSelected]);
            setAllRatePlan([...fillHotelNameForRatePlan({allHotels, dataListRateByHotels})]);
        } else {
            setAllRatePlan([]);
        }
    }, [dataListRateByHotels]);

    useEffect(() => {
        if(!isOnBlurHotel || firstTime){
            setFirstTime(false);
            const request = {
                hotelIds: hotelIds,
                dc: rateType,
            }
            if(filterStatus !== null) {
                request.active = filterStatus
            }
            getListRatesByHotels && getListRatesByHotels(request);
        }
    }, [hotelIds, rateType, filterStatus]);

    const getListRateHotel = () => {
        const request = {
            hotelIds: hotelIds,
            dc: rateType,
        }
        if(filterStatus !== null) {
            request.active = filterStatus
        }
        getListRatesByHotels && getListRatesByHotels(request);
    }

    const onChangeHotel = (ids) => {
        const cloneHotel = allHotels && allHotels.map((el) => el.id
        );
        const isSelectAll = ids.includes('all');
        if(isSelectAll){
            setHotelIds(cloneHotel);
            return;

        }
        setHotelIds(ids);
        if (ids && ids.length <= 0) {
            setRateType([]);
        }
    };

    const onBlurHotel = () => {
        setIsOnBlurHotel(false);
        if ( hotelIds && hotelIds.length > 0) {
            props.onChangeHotel('hotelIds', hotelIds)
            setRatePlanSelected([...ratePlanSelected]);
            setAllRatePlan([...fillHotelNameForRatePlan({allHotels, dataListRateByHotels})]);
            getListRateHotel();
        } else {
            setAllRatePlan([]);
            props.onChangeHotel('hotelIds', [])
        }
        
    }

    const onChangeRates = (selected) => {
        setWarning(false);
        props.onChangeHotel('rateIds', selected)
        setRatePlanSelected(selected);
    };

    const onFilter = (option, filterInput) => {
        if (filterInput === '') {
            return true;
        }
        const optionText = Func.vietnameseStringToUnicode(option.label.toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(filterInput.toLowerCase());
        return optionText.indexOf(inputText) >= 0 || optionText.indexOf(inputText) >= 0;
    }

    const selectFilterSearch = (input, option) => {
        const textOption = option.props?.children?.props?.children.toLowerCase() || ''
        const optionText = Func.vietnameseStringToUnicode(textOption);
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };
    return (
        <Fragment>
            <HMS.FormWrapperItem>
                <Wrapper className='col-md-12 m-top-10-pay-at-hotel'>
                    <AntSelect
                        showArrow
                        allowClear
                        placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.promotions.hotel")).toLowerCase()) }
                        value={ hotelIds }
                        onFocus={() => {setIsOnBlurHotel(true)}}
                        onChange={ ids => {
                            onChangeHotel(ids)
                        } }
                        onBlur={() => onBlurHotel()}
                        filterOption={selectFilterSearch}
                        style={ { width: '100%' } }
                        className="select-types pay-at-hotel-select-hotel"
                        mode="multiple"
                        disabled={props.disabled}
                    >
                        <AntOption value='all' disabled={isCheckHotelIds}>
                            <Tooltip title={ t(`item.campaign.selectAllHotel`) } placement="topLeft">
                                {t(`item.campaign.selectAllHotel`)}
                            </Tooltip>
                        </AntOption>
                        { (allHotels || []).map(hotel => (
                            <AntOption key={ hotel.id } value={ hotel.id }>
                                <Tooltip title={ hotel.name } placement="topLeft">{ `${ hotel.code } - ${ hotel.name }` }</Tooltip>
                            </AntOption>
                        )) }
                    </AntSelect>
                </Wrapper>
                <Wrapper className='col-md-10 m-top-10-pay-at-hotel'>
                    <div className="d-flex filter-pay-at-hotel">
                        <span className="label-filter-pay-at-hotel">
                            {t(`item.campaign.filterStatus`)}:
                        </span>
                        <Radio.Group 
                            value={filterStatus}
                            onChange={e => {
                                setFilterStatus(e.target.value)
                            }}
                            disabled={allRatePlan.length === 0 || props.disabled}
                        >
                            <Radio key={0} value={true}>{t(`item.campaign.active`)}</Radio>
                            <Radio key={1} value={false}>{t(`item.campaign.deactive`)}</Radio>
                            <Radio key={2} value={undefined}>{t(`item.campaign.all`)}</Radio>
                        </Radio.Group>
                    </div>
                </Wrapper>
                <Wrapper className='col-md-12'>
                    <HMS.LoadingComponent spinning={ isFetchingRatesByHotels }>
                        <div className='dual-list-apply-hotel'>
                            <DualListBox
                                canFilter
                                filterPlaceholder={ t('action.search') }
                                filterCallback={ onFilter }
                                options={
                                    (allRatePlan || []).map(item => (
                                        {
                                            label: item.name,
                                            options: item.ratePlans.map(itemRate => ({
                                                ...itemRate,
                                                label: itemRate.code,
                                                value: `${ item.id }:${ itemRate.refId }`,
                                            })),
                                        }))
                                }
                                selected={ [...ratePlanSelected] }
                                onChange={ onChangeRates }
                                icons={ {
                                    moveLeft: <Icon type="left" className="mx-2"/>,
                                    moveAllLeft: <Icon type="double-left" className="mx-2"/>,
                                    moveRight: <Icon type="right" className="mx-2"/>,
                                    moveAllRight: <Icon type="double-right" className="mx-2"/>,
                                } }
                                disabled={ !allRatePlan || (allRatePlan && allRatePlan.length <= 0) || props.disabled }
                            />
                        </div>
                    </HMS.LoadingComponent>
                </Wrapper>
                <Wrapper className="col-md-12 btn-pay-at-hotel-edit">
                    { isWarning && <span className="warning-empty-rate-plan">{t('item.payAtHotel.emptyRatePlan')}</span>}
                </Wrapper>
            </HMS.FormWrapperItem>
        </Fragment>
    );
}

export default ListHotelRate;
